module.exports = __webpack_public_path__ + "static/media/icon_chat.3f32d90b.svg";